import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { useIntl } from 'react-intl';

import Message from 'components/Message';
import When from 'components/When';
import { ICONS } from 'constants/icons';
import { intlMessage } from 'constants/propTypes';
import { bem } from 'helpers/class-name';

import messages from './SkuBanner.messages';
import './SkuBanner.scss';

const { block, element } = bem('sku-banner');

const SkuBanner = ({ title, body, bodyValues, onDismiss, variant }) => {
  const intl = useIntl();
  const isError = variant === 'error';

  return (
    <div className={block({ [variant]: true })} role={isError ? 'alert' : 'status'}>
      <Isvg src={isError ? ICONS.error : ICONS.infoGrey} className={element('icon')} />
      <div className={element('text')}>
        <When predicate={Boolean(title)}>
          <Message as="p" message={title} className={element('title')} />
        </When>
        <Message as="p" message={body} values={bodyValues} className={element('body')} />
      </div>
      <When predicate={Boolean(onDismiss)}>
        <button
          type="button"
          className={element('dismiss')}
          aria-label={intl.formatMessage(messages.dismissLabel)}
          onClick={onDismiss}>
          <Isvg src={ICONS.cross} className={element('dismiss-icon')} />
        </button>
      </When>
    </div>
  );
};

SkuBanner.propTypes = {
  title: intlMessage,
  body: intlMessage.isRequired,
  bodyValues: PropTypes.shape({}),
  onDismiss: PropTypes.func,
  variant: PropTypes.oneOf(['error', 'info']),
};

SkuBanner.defaultProps = {
  variant: 'error',
};

export default SkuBanner;
